<template>
  <div class="topBlogs1">
    <li class="col-md-6 col-sm-12">
      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-4">
          <div class="box-image garden-overlay-scale">
            <div class="garden-img-full-width">
              <img :src="post.featuredImage" alt />
            </div>
            <div class="garden-overlay">
              <router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'post',
                    slug: `${post.slug}`
                  }
                }"
              >
                <span class="fa fa-link"></span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-sm-8 col-xs-8">
          <div class="box-content">
            <router-link
              :to="{
                name: 'SinglePost',
                params: {
                  type: 'post',
                  slug: `${post.slug}`
                }
              }"
              class="garden-hv-child-color-primary"
            >
              <h3 class="title">{{ post.title.substring(0, 60) }}{{ "..." }}</h3>
            </router-link>
            <p class="text-justify text">
              {{ decodeHtml(post.content) | strippedContent }} {{ "..."
              }}
              <router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'post',
                    slug: `${post.slug}`
                  }
                }"
                class="readMore"
              >{{ $t("readMore") }}{{ " " }}</router-link>
            </p>
            <div class="meta">
              <ul>
                <li>
                  <p>
                    <span class="fa fa-user"></span>AfrikEveil
                  </p>
                </li>
                <li>
                  <p>
                    <span class="fa fa-calendar"></span>
                    <timeago :datetime="post.created_at" locale="en"></timeago>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  </div>
</template>
<script>
export default {
  filters: {
    strippedContent: function(string) {
      return string.replace(/<\/?[^>]+>/gi, " ").substring(0, 100);
    }
  },
  methods: {
    decodeHtml: function(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
  },
  name: "TopBlog",
  props: {
    post: {},
    type: String
  }
};
</script>
<style scoped lang="scss">
.topBlogs li .row {
  padding: 15px;
  margin: 15px !important;
  border-radius: 8px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border-bottom: 5px solid #fff;
  background: #fff !important;
}
.garden-img-full-width img {
  margin-top: 20px;
  border-radius: 8px;
  height: 150px;
  object-fit: cover;
}
.box-content .text {
  color: black !important;
  height: 100px;
}
.garden-hv-child-color-primary .title {
  font-size: 14px;
  height: 50px;
  color: #217a51;
  text-align: center;
}
.readMore {
  color: #5bbb2d;
  font-size: 15px;
  font-weight: bold;
  font-style: italic;
}
.readMore:hover {
  color: red;
}

@media (min-device-width: 320px) and (max-device-width: 480px) {
  .garden-img-full-width img,
  .garden-img-full-width {
    height: 200px;
  }
  .garden-hv-child-color-primary .title {
    font-size: 12px;
    margin-top: -20px;
  }
  .meta {
    margin-left: 40px;
    margin-top: 20px;
  }
}
@media (max-device-width: 320px) {
  .garden-img-full-width img,
  .garden-img-full-width {
    height: 150px;
  }
  .garden-hv-child-color-primary .title {
    font-size: 12px;
    margin-top: -20px;
  }
  .meta {
    margin-top: 30px;
  }
}
</style>
